<template>
  <i :class="_class" :style="_style" role="img" :aria-label="_label"></i>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    _class: String | Array | Object,
    _style: String | Array | Object,
    _label: String,
  },
}
</script>
